import { usePatientenProfileStore } from '@/stores/patientenprofile/PatientenprofileStore'
import { useRegelgruppenStore } from '@/stores/regelgruppen/RegelgruppenStore'
import { useRegelnStore } from '@/stores/regeln/RegelnStore'
import { useRouter } from 'vue-router'
import { useFaecherAndFocusStore } from '@/stores/FaecherAndFocusStore'

export function useFaecherHistory() {
  const regelgruppenStore = useRegelgruppenStore()
  const patientenProfil = usePatientenProfileStore()
  const regelnStore = useRegelnStore()
  const faecherStore = useFaecherAndFocusStore()
  const router = useRouter()

  const updateHistory = (index: number = -1) => {
    const newRg = regelgruppenStore.selectedItem
    const newPp = patientenProfil.selectedItem
    const newR = regelnStore.selectedItem

    if (index === -1) index = faecherStore.index

    if (index === 1) {
      void router.push(`/regelgruppen/${newRg?.id ?? ''}`)
    }
    if (index === 2) {
      void router.push(`/regelgruppen/${newRg?.id}/patientenprofil/${newPp?.id ?? ''}`)
    }
    if (index === 3) {
      void router.push(
        `/regelgruppen/${newRg?.id}/patientenprofil/${newPp?.id}/regeln/${newR?.id ?? ''}`
      )
    }
  }

  return { updateHistory }
}
